import { InvestmentReference } from "@rentablo/api/apiv1";

// Logos are keyed by ISIN, or by ticker symbol for securities without one.
export const investmentLogo = (
  logos: Record<string, string | null | undefined>,
  { isin, tickerSymbol }: Pick<InvestmentReference, "isin" | "tickerSymbol">
) => logos[isin || ""] || logos[tickerSymbol || ""];
